// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrandsFilterSort_BrandsFilterSort__xjITp {}
.BrandsFilterSort_BrandsFilterSort__xjITp .BrandsFilterSort_button__vlvGD {
    width: 100%;
    border-radius: 0.375rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(22 163 74 / var(--tw-text-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/components/BrandsFilterSort/BrandsFilterSort.module.css"],"names":[],"mappings":"AAAA,2CAAmB;AAEf;IAAA,WAAyG;IAAzG,uBAAyG;IAAzG,iBAAyG;IAAzG,sBAAyG;IAAzG,0DAAyG;IAAzG,mBAAyG;IAAzG,sBAAyG;IAAzG,qBAAyG;IAAzG,sBAAyG;IAAzG,kBAAyG;IAAzG,mBAAyG;IAAzG,oBAAyG;IAAzG,gBAAyG;IAAzG,oBAAyG;IAAzG;AAAyG","sourcesContent":[".BrandsFilterSort {}\n.BrandsFilterSort .button {\n    @apply w-full text-center py-2 px-1 rounded-md text-sm font-medium text-green-600 border border-green-500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BrandsFilterSort": `BrandsFilterSort_BrandsFilterSort__xjITp`,
	"button": `BrandsFilterSort_button__vlvGD`
};
export default ___CSS_LOADER_EXPORT___;
